import { css } from '@bts-web/utils-style-engine';

export const containerWrapperStyles = css({
  position: 'fixed',
  insetInlineStart: 0,
  top: 0,
  width: '100%',
  height: '100%',
  zIndex: 1000,
  backdropFilter: 'blur(6px)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'rgba(166, 166, 166, 0.50)',
});

export const containerStyles = css({
  flexDirection: 'column',
  textAlign: 'center',
  display: 'flex',
  flex: 'auto',
  width: { base: '100%' },
  height: { base: '100%', lg: 'auto' },
  maxWidth: { base: '100%', lg: '620px' },
  maxHeight: { base: '100%' },
  overflow: 'auto',
  borderRadius: {
    base: 0,
    lg: 'largeBottomRight',
  },
  boxShadow: `0px 0px 8px 0px rgba(0, 0, 0, 0.15)`,
  background: 'screen_background.primary',
  p: {
    base: 'medium',
    lg: 'large',
  },
  pt: {
    base: 'extra_small',
    lg: 'large',
  },
});

export const headerStyles = css({
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
});

export const backButtonStyles = css({
  cursor: 'pointer',
  background: 'transparent',
  border: 'none',
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  color: 'neutrals.text_primary',
});

export const closeLinkStyles = css({
  marginInlineStart: 'auto',
});

export const headerTitleStyles = css({
  flex: 1,
  textAlign: 'center',
  fontSize: 'body.small_medium',
  fontWeight: 'body.small_medium',
  lineHeight: 'body.small_medium',
  letterSpacing: 'body.small_medium',
  color: 'neutrals.text_primary',
});
